'use strict';

var React = require('react');
var PlayStore$1 = require('../../../IconsAndImages/Images/Download/PlayStore.js');
var Link = require('../../../node_modules/@material-ui/core/esm/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PlayStore = function PlayStore(_ref) {
  var fill = _ref.fill;
  return React__default["default"].createElement(Link["default"], {
    href: "https://play.google.com/store/apps/details?id=housecall.pros#details-reviews"
  }, React__default["default"].createElement(PlayStore$1, {
    fill: fill
  }));
};

module.exports = PlayStore;
